import { useLingui } from "@lingui/react";
import { Link } from "@tanstack/react-router";
import { Building2, Users } from "lucide-react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

interface AdminQuickActionsCardProps {
  isSuperAdmin: boolean;
}

export function AdminQuickActionsCard({
  isSuperAdmin,
}: AdminQuickActionsCardProps) {
  const { i18n } = useLingui();

  return (
    <Card>
      <CardHeader>
        <CardTitle>{i18n._("Quick Actions")}</CardTitle>
        <CardDescription>
          {i18n._("Common administrative tasks")}
        </CardDescription>
      </CardHeader>
      <CardContent className="grid gap-2">
        {isSuperAdmin ? (
          <Link
            to="/companies"
            search={{ page: 1, pageSize: 50, status: "all" }}
            className="flex items-center gap-2 p-3 rounded-lg hover:bg-(--color-surface-muted) transition-colors"
          >
            <Building2 className="h-5 w-5 text-(--brand-blue)" />
            <span>{i18n._("Manage Concepts")}</span>
          </Link>
        ) : null}
        <Link
          to="/users"
          search={() => ({ page: 1, pageSize: 50, status: "all" as const })}
          className="flex items-center gap-2 p-3 rounded-lg hover:bg-(--color-surface-muted) transition-colors"
        >
          <Users className="h-5 w-5 text-(--color-warning-text)" />
          <span>{i18n._("Manage Users")}</span>
        </Link>
      </CardContent>
    </Card>
  );
}
